// @ts-check
import React from 'react';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/**
 * @typedef CancellationLoaderProps
 * @property {React.JSX.Element} icon - The icon to display
 * @property {string} title - The title text to display
 */

/**
 * @param {CancellationLoaderProps & import('@liquidweb-dev/undercurrent/Stack').StackProps} props
 */
const CancellationLoader = ({ icon, title, sx, ...rest }) => {
	return (
		<Stack
			flex={1}
			flexDirection="row"
			alignItems="center"
			gap={200}
			padding={300}
			role="status"
			aria-label={title}
			sx={combineSx(
				(theme) => ({
					borderRadius: theme.borderRadius.rounded,
					border: `1px solid ${theme.vars.palette.uc.border.weak}`,
				}),
				sx,
			)}
			{...rest}
		>
			{icon}
			<Typography variant="body-md">{title}</Typography>
		</Stack>
	);
};

export default CancellationLoader;
